import { ServiceOptionsTypes, ServicesValuesTypes } from './Services.types'

export const useServices = (t: (key: string, options?: any) => string) => {
  const servicesOptions: ServiceOptionsTypes[] = [
    {
      value: ServicesValuesTypes.AUTOPAY,
      title: t('searchNearParking.filters.autopay' as keyof typeof t)
    },
    {
      value: ServicesValuesTypes.NAVIPAY,
      title: t('searchNearParking.filters.navi-pay' as keyof typeof t)
    },
    {
      value: ServicesValuesTypes.PARK_AND_FLY,
      title: t('searchNearParking.filters.park-fly' as keyof typeof t)
    },
    {
      value: ServicesValuesTypes.CAR_WASH,
      title: t('searchNearParking.filters.carwash' as keyof typeof t)
    },
    {
      value: ServicesValuesTypes.EV_CHARGERS,
      title: t('searchNearParking.filters.chargers' as keyof typeof t)
    }
    // TODO: Once data is collected for below services, uncomment
    // {
    //   value: ServicesValuesTypes.SCOOTERS,
    //   title: t('searchNearParking.filters.scooters' as keyof typeof t)
    // },
    // {
    //   value: ServicesValuesTypes.VALET,
    //   title: t('searchNearParking.filters.valet' as keyof typeof t)
    // },
  ]

  const additionalFunctionsOptions: ServiceOptionsTypes[] = [
    {
      value: ServicesValuesTypes.AIRPORT_TRANSFER,
      title: t('searchNearParking.filters.airport-transfer' as keyof typeof t)
    },
    {
      value: ServicesValuesTypes.CAR_SEAT,
      title: t('searchNearParking.filters.car-seat' as keyof typeof t)
    },
    {
      value: ServicesValuesTypes.KEY_STORAGE,
      title: t('searchNearParking.filters.key-storage' as keyof typeof t)
    },
    {
      value: ServicesValuesTypes.SAFE,
      title: t('searchNearParking.filters.safe' as keyof typeof t)
    }
  ]

  return { servicesOptions, additionalFunctionsOptions }
}
